<template>
  <v-form v-model="valid" ref="form">
    <v-row>
      <v-col cols="12" md="6">
        <v-text-field v-model="bankName" label="Tên ngân hàng" dense outlined></v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field v-model="bankNumber" label="Số tài khoản" dense outlined></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <p class="mb-0 font-weight-bold">Mã QR</p>
        <p class="mb-0 text-body-2" v-if="!qrcode">Chưa có mã QR</p>
        <div v-else class="d-flex align-end flex-column flex-sm-row">
          <img :src="qrcodeUrl" alt="QR Code" class="qr-code-img" />
          <v-btn
            @click="destroyQrcode"
            class="ml-2"
            icon
            color="error"
            v-if="['super_admin', 'education_manager'].includes(role.type)"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </div>
        <v-file-input
          v-if="['education_manager', 'super_admin'].includes(role.type)"
          class="file-input"
          accept="image/png, image/jpeg, image/bmp"
          prepend-icon="mdi-camera"
          label="Tải lên QR Code"
          @change="onChange"
          ref="file"
        ></v-file-input>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { get } from 'lodash'
import { mapGetters } from 'vuex'
import { Upload } from '@/plugins/api'

export default {
  props: {
    teacher: {
      type: [Object],
      required: true,
      default: () => {}
    }
  },
  data: () => ({
    valid: true,
    bankName: '',
    bankNumber: '',
    qrcode: ''
  }),
  created() {
    this.reset()
  },
  methods: {
    async destroyQrcode() {
      if (!this.qrcode) {
        return
      }
      try {
        await Upload.destroy(this.qrcode.id)
      } catch (error) {
        console.error(error)
      } finally {
        this.qrcode = ''
        this.$alert.success('Cập nhật thành công')
      }
    },
    validate() {
      return this.$refs.form.validate()
    },
    reset() {
      this.bankName = get(this.teacher, 'metadata.bankName', '')
      this.bankNumber = get(this.teacher, 'metadata.bankNumber', '')
      this.qrcode = get(this.teacher, 'qrcode', '')
    },
    resetValidation() {
      this.$refs.form.resetValidation()
    },
    getData() {
      return {
        bankName: this.bankName,
        bankNumber: this.bankNumber
      }
    },
    async onChange(file) {
      if (!file) {
        if (this.qrcode) await Upload.destroy(this.qrcode.id)
        this.qrcode = ''
        return
      }

      try {
        if (this.qrcode) {
          try {
            await Upload.destroy(this.qrcode.id)
          } catch (error) {
            console.error(error)
          }
        }
        let formData = new FormData()
        formData.append('files', file)
        formData.append('refId', this.teacher.id)
        formData.append('ref', 'teacher')
        formData.append('field', 'qrcode')

        const res = await Upload.upload(formData)
        this.qrcode = res[0]
      } catch (error) {
        console.log(error)
      } finally {
        this.$alert.success('Cập nhật thành công')
      }
    }
  },
  watch: {
    teacher(teacher) {
      this.reset()
    }
  },
  computed: {
    ...mapGetters('auth', ['role']),
    qrcodeUrl() {
      if (!this.qrcode) {
        return ''
      }
      return new URL(this.qrcode.url, process.env.VUE_APP_API_ENDPOINT).toString()
    }
  }
}
</script>

<style>
input {
  margin: 8px 0px;
}
.qr-code-img {
  width: 400px;
  height: 400px;
  object-fit: contain;
}
</style>
